import { useLocation, useSearchParams } from 'react-router-dom';

import { ContentStackMetadata, GenericSeason } from '../contentStack.types';

import { getSeriesLinkIfEpisode } from './scp.utils';
import { OnSelectVariant } from './useContentStackEventHandlers';

export type SeasonSectionProps = {
  seriesData: {
    type: 'sequential' | 'topicality';
    seasons: GenericSeason[];
  };
  onClickVariant: OnSelectVariant;
};

const getDefaultSeason = (seasonSection: SeasonSectionProps['seriesData']) =>
  seasonSection.seasons.find(s => s.defaultSelected) ?? seasonSection.seasons[0];

export const useSeasonUrlState = (seriesData: SeasonSectionProps['seriesData']) => {
  const defaultSeason = getDefaultSeason(seriesData);
  const [params, setParams] = useSearchParams({ s: defaultSeason.id });

  const selectedSeason = seriesData.seasons.find(s => s.id === params.get('s')) ?? defaultSeason;

  const setSelectedSeason = (season: GenericSeason) => {
    if (defaultSeason.link === season.link) {
      setParams({}, { replace: true });
    } else {
      setParams({ s: season.id }, { replace: true });
    }
  };

  return [selectedSeason, setSelectedSeason] as const;
};

const REFERER_STATE_KEY = 'seriesReferer';
// provides state for back link from episode page
export const getSeriesRefererState = () => ({
  [REFERER_STATE_KEY]: location.pathname + location.search,
});

export const useSeriesParentLink = (media: ContentStackMetadata) => {
  const seriesReferer = useLocation().state?.[REFERER_STATE_KEY] as string | undefined;
  const { seriesLink, seriesName } = getSeriesLinkIfEpisode(media);

  return {
    // default to link from state if available
    seriesLink: seriesLink && (seriesReferer ?? seriesLink),
    seriesName,
  };
};
